import React, { useState, useEffect } from 'react'
import Header from '../../common/header'
import Footer from '../../common/footer'
import SvgIcon from '../../common/svg-icon/svg-icon'
import { Breadcrumb, Button, Card, CardContent, CardDescription, CardHeader, CardMeta, Image } from 'semantic-ui-react'
import RightSideBar from '../../common/rightsidebar'
import { useHistory } from 'react-router-dom';
import { NewInviteUser } from '../../common/newInviteUser';
import axios from 'axios';
import { BASE_URL } from '../../../config/config';
import { formatIsoMilisecondOnlyTime, formatIsoMilisecondsWithoutTime, getDay, formatIsoMiliseconds, replaceSpaceInName, feedTimeAgo, month_names_short } from '../../../common/helperMethods';
import SEO from '../../../components/seo/SEO'
import './index.scss'

import CardBg from '../../../assets/images/new-images/weare-bg.jpg';
import userAvatar from '../../../assets/images/new-images/user-avatar.png';

const MappesNetworkView = () => {
  const history = useHistory();
  const sections = [
    { key: 'Home', content: 'Home', link: true, href: '/' },
    { key: 'MappesNetwork', content: 'Mappes Network', link: false },
  ]
  const [latestPost, setNetworkSliderSlidesData] = useState([]);

  useEffect(() => {


    axios.get(`${BASE_URL}/api/post/promotional`, {
      "from": 0,
      "size": 10
    }).then((response) => {
      const { data } = response.data
      setNetworkSliderSlidesData(data.rows)

    }).finally(() => {
      //  setLoading(false)
    })

  }, [])

  const get_image = (slide) => {
    const articleMediaType = slide.media && Object.keys(slide.media)[0];

    let imageUrl;
    if (articleMediaType == 'image') {
      imageUrl = (slide.media != undefined) ? slide.media.image.data : '';
      return (
        <div className='main-media-area'>
          <img src={imageUrl} alt='' />
        </div>
      )
    }
  }

  const render_user_avatar = (postdata) => {
    const { user, user_name } = postdata || {};
    if (user != undefined && user.image != undefined) {
      return (
        <Image
          floated='left'
          size='mini'
          src={user.image}
          alt={user_name}
          className='profile_img'
        />
      )
    } else {
      return (
        <Image
          floated='left'
          size='mini'
          src={userAvatar}
          alt={user_name}
          className='profile_img'
        />
      )
    }
  }

  const gotofeed = (data) => {
    history.push(`/feed/post/${data.id}`);
  }

  const gotologin = (data) => {
    history.push(`/otp-login`);
  }

  const render_text = (text) => {
    if (text != undefined && text != '') {
      let t = text;
      // first word of articleText should be capital
      t = t.charAt(0).toUpperCase() + t.slice(1);
      return t;
    }
    return '';
  }


  return (
    <>
      <SEO key="mappes-network-seo"
        robots="index, follow"
        canonicalUrl="/mappes-network"
        alternateLink="/mappes-network"
        pageType={'mappes-network'}

      />
      <Header />
      <div className='innerpages-wrapper'>
        <section className='breadcrumb-section'>
          <div className='mappes-container'>
            <Breadcrumb icon={<SvgIcon name='chevron-right' viewbox="0 0 8 14" />} sections={sections} />
          </div>
        </section>
        <section>
          <div className='mappes-container'>
            <div className='innerpages-wrapper-inner locked-post'>
              <div className='innerpages-left-section'>
                <div className='post-create-card'>
                  <div className='upper-row'>
                    <div className='avatar-left'>
                      <Image
                        floated='left'

                        src={userAvatar}
                      />
                    </div>
                    <div className='upper-row-right'>
                      <div className='textarea cursor-pointer' onClick={() => gotologin()}  >Sign in to share articles, news, updates about your product or company</div>
                      <Button primary onClick={() => gotologin()}>Create Post</Button>
                    </div>
                  </div>
                  <div className='bottom-row'>
                    <Button onClick={() => gotologin()} ><SvgIcon name='media-icon' viewbox="0 0 22 22" /> Add media</Button>
                    <Button onClick={() => gotologin()} ><SvgIcon name='links-icon' viewbox="0 0 22 14" /> Add link</Button>
                    <Button onClick={() => gotologin()} ><SvgIcon name='date-icon' viewbox="0 0 20 22" /> Create an event</Button>
                    <Button onClick={() => gotologin()} ><SvgIcon name='article-icon' viewbox="0 0 22 22" /> Write an Article</Button>
                  </div>
                </div>
                <div className='left-fiter-row mt-4'>
                  <div className='left-col'>
                    What’s happening in <span>Mappes Network</span>
                  </div>
                  <div className='right-col'>

                  </div>
                </div>
                <div className='left-content-row'>
                  <div className='mappes-network-list'>
                    {latestPost.map(slide =>
                      <div className='mappes-network-item'>
                        <Card className='cursor-pointer' onClick={() => gotofeed(slide)}>
                          <CardContent>
                            {render_user_avatar(slide)}
                            <CardHeader>{slide.user ? slide.user.displayName : ''}</CardHeader>
                            <CardMeta><span className='time-col'>{feedTimeAgo(slide.added)}</span> {slide.user.company && <span>|</span>} <span className='company-name'>{slide.user.company}</span></CardMeta>
                            <CardDescription dangerouslySetInnerHTML={{ __html: render_text(slide.text) }}>
                            </CardDescription>
                            <CardDescription>
                              {get_image(slide)}
                              {slide.hashtag}
                            </CardDescription>
                          </CardContent>
                          <CardContent extra className='card-action'>
                            <div className='left-actions'>
                              <ul>
                                <li><SvgIcon name='thumbsup-icon' viewbox="0 0 18 19" />{slide.like_count}</li>
                                <li><SvgIcon name='comment-icon' viewbox="0 0 18 18" />{slide.comment_count}</li>
                                <li><SvgIcon name='share-icon' viewbox="0 0 18 19" /></li>
                              </ul>
                            </div>
                            <div className='right-actions'>
                              <SvgIcon name='cube-icon' viewbox="0 0 18 20" />
                            </div>
                          </CardContent>
                        </Card>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <RightSideBar show={'event'} industry={''} />
              <div className='no-readable-overlap'></div>
            </div>
          </div>
        </section>
        <section className='mappessubcribe-section'>
          <div className='mappes-container'>
            <div className='mappessubcribe-card'>
              <img className='mappessubcribe-bg' src={CardBg} alt='' />
              <div className='mappessubcribe-row'>
                <h2 className='text-white'>Follow Technologies and Receive <br />Curated Market and Industry Intelligence.</h2>
                <NewInviteUser />
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  )
}

export default MappesNetworkView